<template>
  <div :class="{'mobile-frame': mode === 'mobile', 'desktop-frame': mode === 'desktop'}">
    <picture v-if="mode === 'mobile'">
      <source srcset="/wp-content/themes/snappy-theme/assets/images/iphone-se.webp" type="image/webp" />
      <img src="/wp-content/themes/snappy-theme/assets/images/iphone-se.png" />
    </picture>
    <div
      class="page-preview-content"
      :class="{'mobile-content': mode === 'mobile', 'desktop-content': mode === 'desktop', 'loading-content': loading}"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-preview-frame',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.desktop-frame {
    display: flex;
    flex-grow: 1;
    overflow: hidden;
}

.mobile-frame {
    margin: 10px;
    position: relative;
}

.mobile-frame, picture {
    width: 380px;
    height: 799px;
}

.desktop-content {
  width: 100vw;
}

.mobile-content {
    position: absolute;
    top: 118px;
    left: 32px;
    width: 320px;
    height: 568px;
}

.loading-content {
    background: center / 100px no-repeat url("/wp-content/themes/snappy-theme/assets/images/loading2.gif");
}
</style>
